import { takeLatest } from 'redux-saga/effects'

import { API_CALL_FAILURE } from 'Constants/ids'
import {
  SIGN_IN,
  REHYDRATE_TOKEN,
  UPDATE_TOKEN,
  SIGN_UP_CURATOR,
  SIGN_UP_ARTIST,
  SIGN_IN_SPOTIFY,
  SET_ROLE_TO_USER,
  ACCEPT_TERMS,
  GET_CURATOR_RANK,
  SIGN_IN_AS,
  GET_USER_INFO,
} from 'Redux/actions/auth'
import { SET_TOKEN } from 'Redux/actions/influencerActions'
import { CHANGE_EMAIL } from 'Redux/actions/settingsActions'
import {
  CREATE_CAMPAIGN_WITHOUT_SIGNUP,
  RENEW_CAMPAIGN,
  SCHEDULE_CAMPAIGN,
} from 'Redux/actions/campaignActions'

import onSignInSuccess from './OnSignInSuccess'
import onUnauthorizedError from './OnUnathorizedError'
import onTokenRehydrateSuccess from './onTokenRehydrateSuccess'
import onTokenUpdate from './onTokenUpdate'
// import onLogOut from './onLogoutSuccess'
import onSignInFailure from './onSignInFailure'
import onAcceptTerms from './onAcceptTerms'
import onGetCuratorRank from './onGetCuratorRank'
import onChangeEmail from './onChangeEmail'
import onGetUserInfo from './onGetUserInfo'
import onRenewBalance from './onRenewBalance'
import onGetInfluencer from './onGetInfluencer'

// saga watchers
export default function*() {
  // yield takeLatest(LOG_OUT.SUCCESS, onLogOut)
  yield takeLatest(SIGN_IN.SUCCESS, onSignInSuccess)
  yield takeLatest(SIGN_IN_AS.SUCCESS, onSignInSuccess)
  yield takeLatest(CREATE_CAMPAIGN_WITHOUT_SIGNUP.SUCCESS, onSignInSuccess)
  yield takeLatest(SIGN_UP_CURATOR.SUCCESS, onSignInSuccess)
  yield takeLatest(SIGN_UP_ARTIST.SUCCESS, onSignInSuccess)
  yield takeLatest(SIGN_IN_SPOTIFY.SUCCESS, onSignInSuccess)
  yield takeLatest(SET_ROLE_TO_USER.SUCCESS, onSignInSuccess)
  yield takeLatest(SIGN_IN.FAILURE, onSignInFailure)
  yield takeLatest(API_CALL_FAILURE, onUnauthorizedError)
  yield takeLatest(REHYDRATE_TOKEN.SUCCESS, onTokenRehydrateSuccess)
  yield takeLatest(UPDATE_TOKEN.SUCCESS, onTokenUpdate)
  yield takeLatest(ACCEPT_TERMS.SUCCESS, onAcceptTerms)
  yield takeLatest(GET_CURATOR_RANK.SUCCESS, onGetCuratorRank)
  yield takeLatest(CHANGE_EMAIL.SUCCESS, onChangeEmail)
  yield takeLatest(GET_USER_INFO.SUCCESS, onGetUserInfo)
  yield takeLatest(RENEW_CAMPAIGN.SUCCESS, onRenewBalance)
  yield takeLatest(SCHEDULE_CAMPAIGN.SUCCESS, onRenewBalance)
  yield takeLatest(SET_TOKEN, onGetInfluencer)
}
